import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Toast {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
}

interface UIState {
  modals: Record<string, {
    isOpen: boolean;
    props: any;
  }>;
  toasts: Toast[];
  sidebarOpen: boolean;
  sidebarExpanded: boolean;
  theme: 'light' | 'dark';
}

const initialState: UIState = {
  modals: {},
  toasts: [],
  sidebarOpen: false,
  sidebarExpanded: false,
  theme: 'light',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<{ id: string; props?: any }>) => {
      state.modals[action.payload.id] = {
        isOpen: true,
        props: action.payload.props || {},
      };
    },
    closeModal: (state, action: PayloadAction<string>) => {
      if (state.modals[action.payload]) {
        state.modals[action.payload].isOpen = false;
      }
    },
    addToast: (state, action: PayloadAction<Omit<Toast, 'id'>>) => {
      state.toasts.push({
        ...action.payload,
        id: Date.now().toString(),
      });
    },
    removeToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter(t => t.id !== action.payload);
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
    toggleSidebarExpanded: (state) => {
      state.sidebarExpanded = !state.sidebarExpanded;
    },
    setSidebarExpanded: (state, action: PayloadAction<boolean>) => {
      state.sidebarExpanded = action.payload;
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
    },
  },
});

export const {
  openModal,
  closeModal,
  addToast,
  removeToast,
  toggleSidebar,
  setSidebarOpen,
  toggleSidebarExpanded,
  setSidebarExpanded,
  setTheme,
} = uiSlice.actions;
export default uiSlice.reducer;

